import { Descriptions, DescriptionsProps } from "antd";
import dayjs from "dayjs";
import { FC, ReactNode } from "react";
import { displayDateFormat } from "tm-shared/constants";
import { AnyTask } from "tm-shared/types";

import { CoordinatesLink } from "@/shared/navigation/CoordinatesLink";
import { BaseModal } from "@/shared/ui/BaseModal";

const CustomDescriptions = ({
    items,
}: {
    items: DescriptionsProps["items"];
}) => (
    <Descriptions
        layout="horizontal"
        column={1}
        styles={{
            label: { padding: "4px 8px", width: 130 },
            content: { padding: "4px 8px" },
        }}
        bordered
        items={items}
    />
);

interface TaskViewModalProps {
    onClose: () => void;
    title: string;
    children: ReactNode;
    taskInfo?: AnyTask["info"];
}

export const TaskViewModal: FC<TaskViewModalProps> = ({
    onClose,
    title,
    children,
    taskInfo,
}) => {
    const hasRealPerformer =
        taskInfo?.realPerformer?.userId !== taskInfo?.performer?.userId;

    const taskViewInfoItems: DescriptionsProps["items"] = [
        {
            label: "Виконано:",
            children: dayjs(taskInfo?.context?.completedAt).format(
                displayDateFormat.dateTime,
            ),
        },
        {
            label: "Виконавець:",
            children: taskInfo?.realPerformer?.name,
        },
        ...(hasRealPerformer
            ? [
                  {
                      label: "Від імені:",
                      children: taskInfo?.performer?.name,
                  },
              ]
            : []),
        {
            label: "Роль:",
            children: taskInfo?.performer?.role,
        },
    ];

    const visitVerify = taskInfo?.visitVerify;
    const lat = visitVerify?.geo?.latitude;
    const lng = visitVerify?.geo?.longitude;
    const validCoords = !!lat && !!lng;

    const taskViewVerifyItems: DescriptionsProps["items"] = [
        { label: "Перевіряючий:", children: visitVerify?.user?.name },
        { label: "Роль:", children: visitVerify?.user?.role },
        {
            label: "Проскановано:",
            children: dayjs(visitVerify?.scannedAt).format(
                displayDateFormat.dateTime,
            ),
        },
        { label: "Відстань:", children: `${visitVerify?.distance}м.` },

        ...(validCoords
            ? [
                  {
                      label: "Координати:",
                      children: <CoordinatesLink lat={lat} lng={lng} />,
                  },
              ]
            : []),
    ];

    return (
        <BaseModal
            title={title}
            open
            onClose={onClose}
            actions={null}
            mask={{ closable: true }}
            titleStyle={{ fontSize: 20, fontWeight: 600 }}
        >
            {taskInfo && <CustomDescriptions items={taskViewInfoItems} />}

            {visitVerify && <CustomDescriptions items={taskViewVerifyItems} />}

            {children}
        </BaseModal>
    );
};
